import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { TvLoginStore } from '../../pages/app/services/app.store';
import { AppTranslateService } from './app-translate.service';
import { LanguageService } from './languages.service';

export const translationsResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const tvLoginStore = inject(TvLoginStore);
  const languageService = inject(LanguageService);
  const appTranslateService = inject(AppTranslateService);

  const languageIdFromStore = tvLoginStore.getSelectedLanguageId();

  if (languageIdFromStore) {
    const languageId = parseInt(languageIdFromStore);
    const language = languageService.findLanguage(languageId);

    if (language) {
      return languageService.changeSystemLanguageAndPutToStore(language);
    }

    appTranslateService.setDefaultLanguage();
    languageService.setDefaultLanguage();
    return;
  }

  if (languageService.selectedSystemLanguage?.value?.id) {
    languageService.changeSystemLanguage(languageService.selectedSystemLanguage.value);
    return;
  }

  appTranslateService.setDefaultLanguage();
  languageService.setDefaultLanguage();
};
